export default __webpack_public_path__ + "static/media/407.7e95ef7f.jpg";